export const MARKETING_APP = "Marketing";
export const SALES_APP = "Sales";

export const SHOPIFY_CUSTOMER_FINAL_SYNC_IDLE = "idle";
export const SHOPIFY_CUSTOMER_FINAL_SYNC_SUCCESS = "success";
export const SHOPIFY_CUSTOMER_FINAL_SYNC_ERROR = "error";
